import Accordion from "./modules/Accordion.js";
import MenuHandler from "./modules/MenuHandler.js";
import SubmenuHandler from "./modules/SubmenuHandler.js";
import Swiper from "swiper/bundle";
import LoadArticles from "./modules/LoadArticles.js";
import ContentTabs from "./modules/ContentTabs.js";
import MapBox from "./modules/Mapbox.js";
import TableOfContents from "./modules/TableOfContents.js";
import SiblingNav from "./modules/SiblingNav.js";
import DepartmentFilter from "./modules/DepartmentFilter.js";
import CardsExpand from "./modules/CardsExpand.js";
import Event from "./Event/Event.js";
import ModalBox from "./modules/ModalBox.js";
import MarketFinderPDF from "./modules/MarketFinderPDF.js";
import MarketFinder from "./modules/MarketFinder.js";
import CareerHeader from "./modules/CareerHeader.js";
import SplideInit from "./modules/SplideInit.js";
import CareerVideo from "./modules/CareerVideo.js";
import CareerNav from "./modules/CareerNav.js";
import CareerImages from "./modules/CareerImages.js";
import CareerSwiper from "./modules/CareerSwiper.js";
import CareerUploadFile from "./modules/CareerUploadFile.js";
import CareerForm from "./modules/CareerForm.js";
import CareerTableSort from "./modules/CareerTableSort.js";
import MapboxOverlay from "./modules/MapboxOverlay.js";
import FilterSearch from "./modules/FilterSearch.js";
import ExpandableCards from "./modules/ExpandableCards.js";
import EventFilter from "./modules/EventFilter.js";
import SplideScrollerInit from "./modules/SplideScrollerInit.js";
import HeroDropdown from "./modules/HeroDropdown.js";
import GradientOrbs from "./modules/GradientOrbs.js";
import { waitForHubSpotForms } from "./modules/hubspotForms.js";
import {
  generateTableAndIds,
  toggleTable,
  setInitialTableHeight,
} from "./modules/BlogToc";
import "swiper/css/bundle";
import "@splidejs/splide/css/core";
import productUpdatesFilter from "./modules/productUpdatesFilter.js";
import { popup } from "./modules/popup";
import { forcedPopup } from "./modules/forced-popup";
import { listenForScroll, updateNavOffset } from "./modules/ScrollHandler";
import { queryParamFormOpener } from "./modules/queryParamFormOpener.js";
import { accordionModule } from "./modules/accordionModule.js";
import bookingGalleryDropdown from "./modules/bookingGalleryDropdown.js";
import { directoryFilter, directorySearch } from "./modules/directoryGrid.js";
import { readMoreSidebar } from "./modules/ReadMoreSidebar.js";
import PlatformMap from "./modules/PlatformMap.js";

function init() {
  listenForScroll();

  const accordionModules = document.querySelectorAll("section.accordion");
  if (accordionModules) {
    accordionModules.forEach((module) => accordionModule(module));
  }

  const hasDirectoryGrid = document.querySelector(".directory-grid");
  if (hasDirectoryGrid) {
    directoryFilter();
    directorySearch();
  }

  document
    .querySelectorAll("form.reports-filter")
    .forEach((form) => new FilterSearch(form).init());
  const hasToc = document.querySelector(".blog-toc");
  const tocButton = document.querySelector("#blog-toc-button");
  if (hasToc) {
    generateTableAndIds();
    setInitialTableHeight();
    tocButton.addEventListener("click", toggleTable);
  }

  const submenuHandler = new SubmenuHandler();
  const menuHandler = new MenuHandler();
  const contentTabModules = document.querySelectorAll(".content-tabs");
  if (contentTabModules) {
    contentTabModules.forEach((module) => {
      new ContentTabs(module);
    });
  }

  const expandableCards = document.querySelectorAll(".cards--expandable");
  if (expandableCards) {
    expandableCards.forEach((module) => {
      new CardsExpand(module);
    });
  }

  const contact_map = document.querySelector(".contact-map");
  if (contact_map) {
    new MapBox();
    new MapboxOverlay();
  }

  const table_of_contents = document.querySelectorAll(".table-of-contents");
  if (table_of_contents) {
    table_of_contents.forEach((element) => {
      new TableOfContents(element);
    });
  }

  const sibling_nav = document.querySelector(".sibling-nav");
  if (sibling_nav) {
    new SiblingNav();
  }

  const department_filter = document.querySelector(".employees__filter");
  if (department_filter) {
    new DepartmentFilter(department_filter);
  }

  const quoteSliders = document.querySelectorAll(".quotes--slider");
  if (quoteSliders.length > 0) {
    quoteSliders.forEach((el) => {
      const swiperEl = el.querySelector(".swiper");
      const wrapper = swiperEl.querySelector(".swiper-wrapper");
      const originalSlides = [...wrapper.querySelectorAll(".swiper-slide")];
      const originalCount = originalSlides.length;

      if (originalCount > 0 && originalCount < 6) {
        const copies = Math.ceil(6 / originalCount);
        for (let i = 1; i < copies; i++) {
          originalSlides.forEach((slide) =>
            wrapper.appendChild(slide.cloneNode(true)),
          );
        }
      }

      new Swiper(swiperEl, {
        slidesPerView: 1.25,
        spaceBetween: 12,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 1.25,
            spaceBetween: 24,
          },
          1280: {
            slidesPerView: 2,
            spaceBetween: 36,
          },
          1920: {
            slidesPerView: 2.5,
            spaceBetween: 36,
          },
        },
        pagination: {
          el: el.querySelector(".swiper-pagination"),
          type: "custom",
          renderCustom(swiper, current) {
            const logicalIndex = (current - 1) % originalCount;
            return Array.from({ length: originalCount }, (_, i) => {
              const active =
                i === logicalIndex ? " swiper-pagination-bullet-active" : "";
              return `<span class="swiper-pagination-bullet${active}"></span>`;
            }).join("");
          },
        },
        navigation: {
          nextEl: el.querySelector(".swiper-button-next"),
          prevEl: el.querySelector(".swiper-button-prev"),
          addIcons: false,
        },
      });
    });
  }

  const heroSliders = document.querySelectorAll(".slider .swiper");
  if (heroSliders.length > 0) {
    heroSliders.forEach((slider) => {
      const wrapper = slider.querySelector(".swiper-wrapper");
      const originalSlides = [...wrapper.querySelectorAll(".swiper-slide")];
      const originalCount = originalSlides.length;

      if (originalCount > 0 && originalCount < 6) {
        const copies = Math.ceil(6 / originalCount);
        for (let i = 1; i < copies; i++) {
          originalSlides.forEach((slide) =>
            wrapper.appendChild(slide.cloneNode(true)),
          );
        }
      }

      new Swiper(slider, {
        slidesPerView: 1.125,
        spaceBetween: 12,
        loop: true,
        autoHeight: true,
        centeredSlides: true,
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          1279: {
            spaceBetween: 36,
            slidesPerView: 1.5,
          },
        },
      });
    });
  }

  const pointSliders = document.querySelectorAll(
    ".key-points--mobile .key-points__inner .swiper",
  );

  if (pointSliders.length > 0) {
    pointSliders.forEach((slider) => {
      let count = 0;
      new Swiper(slider, {
        loop: true,
        slidesPerView: 1.25,
        breakpoints: {
          640: {
            slidesPerView: 2.5,
          },
        },
        allowTouchMove: true,
        pagination: {
          el: slider.querySelector(".swiper-pagination"),
        },
        navigation: {
          prevEl: slider.querySelector(".swiper-button-prev"),
          nextEl: slider.querySelector(".swiper-button-next"),
        },
        on: {
          beforeTransitionStart: function (ev) {
            if (ev.el.querySelector(".swiper-slide-next")) {
              ev.el
                .querySelector(".swiper-slide-next")
                .classList.add("swiper-transition");
            }
          },
          beforeSlideChangeStart: function (ev) {
            if (count == 0) {
              slider
                .querySelector(".swiper-button-prev")
                .classList.add("greyed-out");
              count++;
            } else if (count > 0) {
              slider
                .querySelector(".swiper-button-prev")
                .classList.remove("greyed-out");
              count++;
            }
          },
        },
      });
    });
  }

  const bookingGallery = document.querySelectorAll(".booking-gallery");
  if (bookingGallery.length > 0) {
    bookingGallery.forEach((gallery) => {
      bookingGalleryDropdown(gallery);
      new Swiper(gallery.querySelector(".swiper"), {
        slidesPerView: 1,
        effect: "fade",
        crossFade: true,
        autoplay: {
          delay: 4000,
        },
      });
    });
  }

  let tally = 0;
  const timelines = document.querySelectorAll(".timeline .swiper");

  timelines.forEach((timeline) => {
    new Swiper(timeline, {
      loop: true,
      slidesPerView: 4,
      allowTouchMove: true,
      spaceBetween: 60,
      navigation: {
        prevEl: timeline.querySelector(".swiper-button-prev"),
        nextEl: timeline.querySelector(".swiper-button-next"),
      },
      breakpoints: {
        320: {
          slidesPerView: 1.25,
          spaceBetween: 40,
        },
        560: {
          slidesPerView: 2.5,
        },
        650: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        1050: {
          slidesPerView: 2.65,
        },
        1280: {
          slidesPerView: 3,
        },
        1560: {
          slidesPerView: 4,
        },
      },
      on: {
        beforeSlideChangeStart: function (ev) {
          if (tally == 0) {
            timeline
              .querySelector(".swiper-button-prev")
              .classList.add("greyed-out");
            tally++;
          } else if (tally > 0) {
            timeline
              .querySelector(".swiper-button-prev")
              .classList.remove("greyed-out");
            tally++;
          }
        },
      },
    });
  });

  const accordions = document.querySelectorAll(".accordion");
  if (accordions.length > 0) {
    accordions.forEach((accordion) => {
      new Accordion(accordion);
    });
  }

  const event = new Event();

  const loadArticles = new LoadArticles();

  const modals = document.querySelectorAll(".modal-box");
  if (modals) {
    modals.forEach((modal) => {
      new ModalBox(modal.id);
    });
  }

  if (document.querySelector(".market-finder")) {
    const productFinderPDF = new MarketFinderPDF();
    const productFinder = new MarketFinder();
  }

  const careerHeader = new CareerHeader();
  const careerSwiper = new CareerSwiper();
  const careerUploadFile = new CareerUploadFile();
  const careerForm = new CareerForm();

  if (document.querySelector(".career-teams")) {
    const video = new CareerVideo();
    const careerNav = new CareerNav();
    const careerImages = new CareerImages();
  }

  const spliders = document.querySelector(".career-teams__slider.splide");
  if (spliders) {
    const splideInit = new SplideInit();
  }

  const splideScroller = document.querySelector(
    ".brands-mobile__container-outer.splide",
  );
  if (splideScroller) {
    const splideScrollerInit = new SplideScrollerInit();
  }

  const expandableCardsModules = document.querySelectorAll(".cards-expandable");
  if (expandableCardsModules) {
    expandableCardsModules.forEach((element) => new ExpandableCards(element));
  }

  const eventFilters = document.querySelectorAll(".events-list--show_all");
  if (eventFilters) {
    eventFilters.forEach((element) => new EventFilter(element));
  }

  const banner = document.querySelector(".banner");
  if (banner) {
    const button = document.querySelector(".banner__close-button");
    if (!sessionStorage.getItem("banner-cleared")) {
      banner.classList.remove("banner--hidden");
      updateNavOffset();
    }
    button.addEventListener("click", () => {
      banner.classList.add("banner--hidden");
      sessionStorage.setItem("banner-cleared", true);
      updateNavOffset();
    });
  }

  const heroDropdown = document.querySelector(".hero-dropdown");
  if (heroDropdown) {
    new HeroDropdown();
  }
  const gradientAnimations = document.querySelectorAll(".gradient-animation");
  if (gradientAnimations) {
    gradientAnimations.forEach((animElement) => {
      new GradientOrbs(animElement);
    });
  }

  productUpdatesFilter();
  popup();
  forcedPopup();
  queryParamFormOpener();
  waitForHubSpotForms();
  readMoreSidebar();
  const blocks = document.querySelectorAll(".platform-map");
  blocks.forEach((block) => {
    new PlatformMap(block);
  });

  document.querySelectorAll(".footer-nav__button").forEach((button) => {
    button.addEventListener("click", () => {
      button.closest(".footer-nav__item").classList.toggle("footer-nav__item--open");
    });
  });
}

// Yield to the browser to paint the LCP element before running heavy init
requestAnimationFrame(() => setTimeout(init, 0));
